import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './StoreListPage.scss'

const StoreListPage = () => {
	return (
		<div className="main-content store-page">
			<GamificationBlock
				domId={WIDGETS.store.domId}
				url={WIDGETS.store.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default StoreListPage
